class ShowMoreLess {
	constructor(container) {
		this.container = container;
		this.charsAmount = this.container.getAttribute('data-chars-amount');
		this.rowsAmount = this.container.getAttribute('data-rows-amount');
		this.rowsAmountMob = this.container.getAttribute('data-rows-amount-mob');
		this.textContainer = this.container.querySelector(
			'.js-show-more-text-content',
		);
		this.toggler = document.createElement('button');
		this.toggler.classList.add(
			'btn',
			'btn-link',
			'show-more-less-block__toggler',
			'js-show-more-toggler',
		);
		this.togglerShowMoreText = this.container.querySelector(
			'.js-toggler-show-more-text',
		).value;
		this.togglerShowLessText = this.container.querySelector(
			'.js-toggler-show-less-text',
		).value;
		if (this.charsAmount) {
			this.visibleText = this.textContainer.innerHTML.slice(
				0,
				this.charsAmount,
			);
			this.hiddenText = this.textContainer.innerHTML.slice(this.charsAmount);
		}
	}

	setContentWithCharsLimit() {
		this.textContainer.innerHTML = `${this.visibleText}<span class="dots">...</span>
            <span class="hidden more-text">${this.hiddenText}</span>`;

		if (!this.container.querySelector('js-show-more-toggler')) {
			this.textContainer.after(this.toggler);

			this.toggler.textContent = this.togglerShowMoreText;
		}
	}

	toggleContentWithCharsLimit() {
		const moreText = this.textContainer.querySelector('.more-text');
		const dots = this.textContainer.querySelector('.dots');

		moreText.classList.toggle('hidden');
		dots.classList.toggle('hidden');

		if (moreText.classList.contains('hidden')) {
			this.toggler.textContent = this.togglerShowMoreText;
		} else {
			this.toggler.textContent = this.togglerShowLessText;
		}
	}

	setContentWithRowsLimit() {
		this.textContainer.classList.add(
			'is-trimmed',
			'show-more-less-block__text',
		);

		if (window.innerWidth >= 992) {
			this.textContainer.style.webkitLineClamp = this.rowsAmount;
		} else {
			this.textContainer.style.webkitLineClamp = this.rowsAmountMob;
		}

		if (!this.container.querySelector('js-show-more-toggler')) {
			this.textContainer.after(this.toggler);
			this.toggler.textContent = this.togglerShowMoreText;
		}
	}

	toggleContentWithRowsLimit() {
		this.textContainer.classList.toggle('is-trimmed');

		if (this.textContainer.classList.contains('is-trimmed')) {
			this.toggler.textContent = this.togglerShowMoreText;
		} else {
			this.toggler.textContent = this.togglerShowLessText;
		}
	}

	getCountOfTextLines() {
		this.textContainer.style.webkitLineClamp = null;
		const textHeight = this.textContainer.offsetHeight;
		const lineHeight = parseInt(this.textContainer.style.lineHeight, 10);
		this.countOfTextLines = parseInt(textHeight / lineHeight, 10);
	}

	initContentWithCharsLimit() {
		if (this.textContainer.textContent.length > this.charsAmount) {
			this.setContentWithCharsLimit();

			if (!this.toggler.classList.contains('toggler-init')) {
				this.toggler.classList.add('toggler-init');

				this.toggler.addEventListener('click', () => {
					this.toggleContentWithCharsLimit();
				});
			}
		}
	}

	initContentWithRowsLimit() {
		if (
			(window.innerWidth < 992 && this.countOfTextLines > this.rowsAmountMob) ||
			(window.innerWidth >= 992 && this.countOfTextLines > this.rowsAmount)
		) {
			this.setContentWithRowsLimit();

			if (!this.toggler.classList.contains('toggler-init')) {
				this.toggler.classList.add('toggler-init');

				this.toggler.addEventListener('click', () => {
					this.toggleContentWithRowsLimit();
				});
			}
		}
	}

	listeners() {
		this.toggler.remove();

		if (this.charsAmount) {
			this.initContentWithCharsLimit();
		} else if (this.rowsAmount) {
			this.getCountOfTextLines();
			this.initContentWithRowsLimit();
		}
	}

	init() {
		this.listeners();

		window.addEventListener('resize', () => {
			this.listeners();
		});
	}
}

export default ShowMoreLess;
